/**
 * Public barrel export for the PlayerSearchResultRow component
 * @module components/shared/search-modal/PlayerSearchResultRow
 */

export { default } from "./PlayerSearchResultRowContainer";
